import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class SignInResponse {
  @jsonMember(String)
  public readonly token!: string;
}
